import React from 'react';
import {TextEditor} from 'sulu-admin-bundle/containers';
import TextArea from 'sulu-admin-bundle/components/TextArea';
import {Grid, Number, Button, Loader, Icon, Checkbox} from 'sulu-admin-bundle/components';
import PromptSelect from '../components/PromptSelect';
import Tooltip from 'sulu-admin-bundle/components/Tooltip';

class AiEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    handleChange = (newValue) => {
        const {value = {}, onChange} = this.props;

        onChange({
            ...value,
            generatedText: newValue,
        });
    }

    handlePromptSelectChange = (newValue) => {
        const {value = {}, onChange} = this.props;

        onChange({
            ...value,
            promptSelected: newValue,
            promptText: newValue,
        });
    };

    handleMaxCharacters = (newValue) => {
        const {value = {}, onChange} = this.props;

        onChange({
            ...value,
            maxCharacters: newValue,
        });
    };

    handlePromptTextChange = (newValue) => {
        const {value = {}, onChange} = this.props;

        onChange({
            ...value,
            promptText: newValue,
        });
    };

    handleRegionalerBezug = (newValue) => {
        const {value = {}, onChange} = this.props;

        onChange({
            ...value,
            regionalerBezug: newValue,
        });
    }

    handleAiButtonClick = () => {
        const {value = {}, onChange} = this.props;

        this.setState({
            loading: true
        });

        fetch('/admin/ai-editor', {
            method: 'POST',
            body: JSON.stringify({
                uuid: this.props.router.attributes.id,
                promptText: value.promptText,
                maxCharacters: value.maxCharacters,
                regionalerBezug: value.regionalerBezug,
            }),
        }).then((response) => {
            return response.text();
        }).then((result) => {
            onChange({
                ...value,
                generatedText: result,
            });

            this.setState({
                loading: false
            });
        });
    }

    render() {
        const margins = {
            marginBlockEnd: 12
        };

        const {value = {}, dataPath, error} = this.props;

        return (
            <>
                <Grid>
                    <Grid.Item colSpan={4}>
                        <div style={margins}>
                            <label htmlFor={`${dataPath}.promptSelected`} style={{display: 'block', marginBlockEnd: 4}}>Vorschläge</label>
                            <PromptSelect
                                id={`${dataPath}.promptSelected`}
                                value={value.promptSelected}
                                onChange={this.handlePromptSelectChange}
                                uuid={this.props.router.attributes.id}
                            />
                        </div>
                    </Grid.Item>
                    <Grid.Item colSpan={4}>
                        <div style={margins}>
                            <label htmlFor={`${dataPath}.maxCharacters`} style={{display: 'block', marginBlockEnd: 4}}>Zeichen</label>
                            <Number
                                id={`${dataPath}.maxCharacters`}
                                value={value.maxCharacters ?? 500}
                                onChange={this.handleMaxCharacters}
                            />
                        </div>
                    </Grid.Item>
                    <Grid.Item colSpan={4}>
                        <div style={margins}>
                            <label htmlFor={`${dataPath}.regionalerBezug`} style={{display: 'block', marginBlockEnd: 4}}>&nbsp;</label>
                            <Checkbox
                                value="1"
                                checked={value.regionalerBezug}
                                onChange={this.handleRegionalerBezug}
                            >Regional</Checkbox>
                        </div>
                    </Grid.Item>
                    <Grid.Item>
                        <div style={margins}>
                            <label htmlFor={`${dataPath}.promptText`} style={{display: 'block', marginBlockEnd: 4}}>Ergänzende Angaben, um Prompt zu erweitern</label>
                            <TextArea
                                id={`${dataPath}.promptText`}
                                value={value.promptText}
                                onChange={this.handlePromptTextChange}
                            />
                        </div>
                    </Grid.Item>
                    <Grid.Item>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginBlockEnd: 20}}>
                            <Button
                                skin={'primary'}
                                icon={'su-magic'}
                                onClick={this.handleAiButtonClick}
                                disabled={typeof this.props.router.attributes.id === 'undefined'}
                            >
                                Text generieren
                            </Button>
                            {typeof this.props.router.attributes.id === 'undefined' &&
                                <Tooltip
                                    label="Um alle notwendigen Informationen für die Anfrage vorliegen zu haben, muss die Seite angelegt sein."
                                    aria-label="Um alle notwendigen Informationen für die Anfrage vorliegen zu haben, muss die Seite angelegt sein."
                                >
                                    <Icon name="su-information" />
                                </Tooltip>
                            }
                        </div>
                    </Grid.Item>
                    <Grid.Item>
                        <div style={margins}>
                            {this.state.loading && <Loader />}
                            {!this.state.loading && (
                                <TextEditor
                                    adapter="ckeditor5"
                                    id={`${dataPath}.generatedText`}
                                    value={value.generatedText ?? ''}
                                    valid={!error}
                                    onChange={this.handleChange}
                                />
                            )}
                        </div>
                    </Grid.Item>
                </Grid>
            </>
        );
    }
}

export default AiEditor;